export default __webpack_public_path__ + "static/media/491.1eb58299.png";